import React from "react";
import { PiWarningFill } from "react-icons/pi";
import { IoClose } from "react-icons/io5";

const UsageLimitBanner = ({
  usedMinutes,
  totalMinutes,
  resetDay = "Monday",
  onUpgrade,
  onDismiss,
  className = "",
}) => {
  const limitReached = usedMinutes >= totalMinutes;
  const headline = limitReached ? "Weekly limit reached." : "Approaching weekly limit.";

  return (
    <div
      role="alert"
      className={`w-full flex items-center gap-2 sm:gap-3 rounded-xl border border-[#FCD9A8] bg-[#FFF6E5] px-2 py-2 sm:px-4 sm:py-3 font-inter ${className}`}
    >
      <span className="shrink-0 flex items-center justify-center w-7 h-7 sm:w-8 sm:h-8 rounded-md sm:rounded-lg bg-[#F8B65C] text-white">
        <PiWarningFill className="w-4 h-4 sm:w-5 sm:h-5" />
      </span>

      <p className="flex-1 min-w-0 text-xs sm:text-sm text-[#7A4A00] leading-snug truncate sm:whitespace-normal">
        <span className="font-semibold text-[#5C3A00]">{headline}</span>
        <span className="hidden md:inline">
          {limitReached
            ? ` You've used all ${totalMinutes} free minutes this week. Resets ${resetDay}.`
            : ` You've used ${usedMinutes} of ${totalMinutes} free minutes this week. Resets ${resetDay}.`}
        </span>
        <span className="hidden sm:inline md:hidden">
          {limitReached
            ? ` All ${totalMinutes} free minutes used.`
            : ` ${usedMinutes} of ${totalMinutes} free minutes used.`}
        </span>
        <span className="sm:hidden">
          {limitReached
            ? ` ${totalMinutes}/${totalMinutes} min`
            : ` ${usedMinutes}/${totalMinutes} min`}
        </span>
      </p>

      <button
        type="button"

        onClick={onUpgrade}
        className="shrink-0 text-xs sm:text-sm font-semibold text-[#407BFF] hover:text-[#3AB1F6] transition"
      >
        Upgrade
      </button>

      <button
        type="button"
        onClick={onDismiss}
        aria-label="Dismiss notification"
        className="shrink-0 text-[#7A4A00] hover:text-[#5C3A00] transition"
      >
        <IoClose className="w-4 h-4 sm:w-5 sm:h-5" />
      </button>
    </div>
  );
};

export default UsageLimitBanner;
